import { getAppName, getNativeInfo } from '@docs/common'
import { APP_ENV } from './appenv'
import { StoreArea, SYS_ENV_STORE_MAP, transCountryToStoreArea } from './locales'

function getCookie(name: string) {
  if (typeof window !== 'undefined') {
    const value = `; ${document.cookie}`
    const parts: Array<string> = value.split(`; ${name}=`)
    if (parts.length) return parts?.pop()?.split(';').shift()
  }
  return ''
}
export const getStoreArea = async () => {
  let storeArea = getCookie('store_area')
  if (!storeArea) {
    const nativeInfo = await getNativeInfo().catch(e => Promise.resolve({ country: 'us' }))

    storeArea = transCountryToStoreArea(nativeInfo.country)
  }
  return storeArea as StoreArea
}
export const getStoreOrigin = async () => {
  const storeArea = await getStoreArea()
  const sysEnv = SYS_ENV_STORE_MAP[storeArea]

  const envOrigin = {
    qa: 'https://security-mall-qa.eufylife.com',
    us: 'https://security-mall.eufylife.com',
    eu: 'https://security-mall-eu.eufylife.com',
  }
  return [APP_ENV === 'pr' ? envOrigin[sysEnv] : envOrigin['qa'], storeArea]
}

export const getApiBaseUrl = async (version: string = 'v1') => {
  const storeArea = await getStoreArea()
  const appName = await getAppName()
  const formatAppName = `${appName}`.replace(/\s+/g, '-').toLowerCase()
  const appNameServerMap: Record<string, string> = {
    'eufy-security': 'security',
    'eufy_mega': 'security',
    'eufy-care': 'care',
    'eufy-baby': 'care',
  }
  const sysEnv = SYS_ENV_STORE_MAP[storeArea]
  const server = appNameServerMap[formatAppName]
  const envOrigin = {
    qa: `https://${server}-app-qa.eufylife.com`,
    us: `https://${server}-app.eufylife.com`,
    eu: `https://${server}-app-eu.eufylife.com`,
  }
  return [`${APP_ENV === 'pr' ? envOrigin[sysEnv] : envOrigin['qa']}/${version}`, storeArea]
}
